import moment from "moment";
import Vue from 'vue';
import { router } from '@/router';
import ReportsService from '@/services/ReportsService';
import _ from 'lodash';
import store from '@/store';


function initialState() {
    return {
        MunicipaltyReportsExcelFileName: null,
        MunicipaltyReportsPDFFileName: null,
        dropDownObject: {
            fromDate: null,
            endDate: null,
            cinema_name: null,
            cinema_id: null,
        },
        MunicipaltyReport: [],
        chartData: {
            labels: [],
            datasets: [
                //     {
                //     label: '',
                //     backgroundColor: '#f87979',
                //     data: []
                // }
            ]
        },
        chartOptions: {
            responsive: true,
            maintainAspectRatio: false
        }
    }
}

const state = initialState();

const mutations = {
    SET_MUNICIPALTY_EXCEL_FILE_NAME: (state, payload) => {
        state.MunicipaltyReportsExcelFileName = payload;
    },
    SET_MUNICIPALTY_PDF_FILE_NAME: (state, payload) => {
        state.MunicipaltyReportsPDFFileName = payload;
    },
    SET_DROP_DOWN_VALUES: (state, payload) => {
        switch (payload.name) {
            case 'isCinema':
                state.dropDownObject.cinema_id = payload['selectedItem'] ? payload.selectedItem.cine_id : null;
                state.dropDownObject.cinema_name = payload['selectedItem'] ? payload.selectedItem.cine_name : null;
                break;
            case 'fromDate':
                state.dropDownObject.fromDate = payload['event'] ? payload['event'] : null;
                break;
            case 'endDate':
                state.dropDownObject.endDate = payload['event'] ? payload['event'] : null;
                break;
            default: console.log('Municipalty Report :( Sorry, we are enable to set value.');
        }
    },
    SET_MUNICIPALTY_REPORT: (state, payload) => {
        state.MunicipaltyReport = payload || []
    }
}

const actions = {
    onMunicipaltyReportDropDownHandler: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_DROP_DOWN_VALUES', payload);
    },
    onFetchMunicipaltyReport: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_MUNICIPALTY_REPORT', [])
        let loader = Vue.$loading.show();
        state.dropDownObject["endDate"]=moment(state.dropDownObject["endDate"]).format("YYYY-MM-DD")
        state.dropDownObject["fromDate"]=moment(state.dropDownObject["fromDate"]).format("YYYY-MM-DD")

        await ReportsService.GetMunicipaltyReport(state.dropDownObject)
            .then(async (response) => {
                loader.hide();
                const { data } = response;
                console.log('data :', data);
                if (data.status) {
                    if (data.Records && data.Records.length > 0) {
                        commit('SET_MUNICIPALTY_REPORT', data.Records)
                        store.dispatch('onSetChartData', data.Records)
                        await commit('SET_MUNICIPALTY_EXCEL_FILE_NAME', data['ExcelName'] || null);
                        await commit('SET_MUNICIPALTY_PDF_FILE_NAME', data['PDFName'] || null);
                    } else {
                        Vue.toasted.show('No Records Found.');
                    }
                } else {
                    Vue.toasted.show(data.message);
                }
            }).catch((error) => {
                Vue.toasted.show("Catch Error on Municipalty Reports", error);
            });
    },
}

const getters = {
    getMunicipaltyReportsSelectedCinema: state => state.dropDownObject.cinema_name,
    getMunicipaltyReportFromDate: state => state.dropDownObject.fromDate,
    getMunicipaltyReportEndDate: state => state.dropDownObject.endDate,
    getMunicipaltyReportData: state => state.MunicipaltyReport,

    getMunicipaltyReportsExcelFileName: state => state.MunicipaltyReportsExcelFileName,
    getMunicipaltyReportsPDFFileName: state => state.MunicipaltyReportsPDFFileName,
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/MunicipaltyReport.js